import React, { PureComponent } from 'react';
import withData from 'fetch-hoc';
import { connect } from 'unistore/react';

import StaticMap from './StaticMap';
import Labels from './Labels';

import { currentDataSelector } from '../../Selectors';
import Icon from '../../../../../core/scripts/components/Icon';

const noColorIds = [
  'ALA',
  'ALB',
  'AND',
  'BLR',
  'BIH',
  'FRO',
  'GIB',
  'GRL',
  'GGY',
  'IMN',
  'ISL',
  'JEY',
  'XKX',
  'LIE',
  'MDA',
  'MCO',
  'MNE',
  'MKD',
  'NOR',
  'RUS',
  'SMR',
  'CHE',
  'SRB',
  'SJM',
  'TUR',
  'UKR',
  'VAT'
];

class EuropeMap extends PureComponent {
  render() {
    const { currentData } = this.props;

    if (!currentData) {
      return null;
    }

    return (
      <div className="result-map result-map-eu" ref={this.props.mapRef}>
        <div className="result-headline">Wahlgewinner in Europa</div>
        <div className="result-subline">Die stärkste Partei in den Mitgliedsländern nach Fraktionszugehörigkeit</div>
        <div className="eu-map-participants-wrap">
          <div className="eu-map-participants">
              <div className="participants"><Icon type="star"/>{this.props.currentData.participants}</div>
              <div className="participants-label">Staaten</div>
          </div>
        </div>
        <StaticMap strokeWidth={1} labels={Labels.europe} data={this.props.data} noColorIds={noColorIds} />
      </div>
    );
  }
}

export default connect(state => ({
  currentData: currentDataSelector(state)
}))(withData(props => {
  const { startYear } = props.currentData;

  if (startYear <= 1989) {
    return 'data/ew_eu_hist_1994.topo.json';
  }

  return 'data/ew_eu_hist.topo.json';
})(EuropeMap));
